module.exports = __webpack_public_path__ + "static/media/jac_logo.bad16555.svg";